import { mapActions, mapGetters } from 'vuex';

import { REQUEST_LIFECYCLE } from '@/utils/request-lifecycle';

export default {
  REQUEST_LIFECYCLE,
  computed: {
    ...mapGetters('dashboard/workOrders', [
      'workOrdersKey',
      'getWorkOrdersMetaByBucketName',
      'getRawWorkOrdersByBucketName',
    ]),
    meta () {
      return this.getWorkOrdersMetaByBucketName(this.workOrdersBucketName, this.workOrdersKey);
    },
    rawWorkOrders () {
      return this.getRawWorkOrdersByBucketName(this.workOrdersBucketName, this.workOrdersKey);
    },
  },
  methods: {
    ...mapActions('dashboard/workOrders', [
      'fetchWorkOrders',
      'resetWorkOrders',
    ]),
  },
};
